const { createSlice } = require("@reduxjs/toolkit");

const formValidityInitialState = {
  formValidity: false,
};

const formValiditySlice = createSlice({
  name: "formValidity",
  initialState: formValidityInitialState,
  reducers: {
    editFormValidity(state: any, action: any) {
      state.formValidity = action.payload;
    },
  },
});

export const formValidityActions = formValiditySlice.actions;

export default formValiditySlice.reducer;
